import { PaginationType } from "src/models/common/PaginationType.model";
import { UpdateAffidavitCertificate } from "src/models/AffidavitCertificateUpdate.model";
import apiSlice from "./ApiSlice";

export const affidavitCertificateApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // POST REQUEST
    getaffidavitCertificate: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/list/pagination",
        method: "POST",
        body,
      }),
    }),

    // GET REPORT
    getaffidavitCertificateZip: builder.mutation({
      query: (srn) => ({
        url: `/affidavit-certificate/zip`,
        params: { srn },
        method: "GET",
      }),
    }),

    // Export Data
    exportHistoryaffidavitCertificateData: builder.mutation({
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/list/pagination",
        method: "POST",
        body,
      }),
    }),

    // GET SINGLE
    getSingleaffidavitCertificate: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (affidavitCertificateId) => ({
        url: `/affidavit-certificate/admin/view`,
        params: { id: affidavitCertificateId },
        method: "GET",
      }),
    }),

    // GET FLOW
    getaffidavitCertificateApplicationFlow: builder.mutation({
      query: (id) => ({
        url: `/affidavit-certificate/get-status-history`,
        params: { id: id },
        method: "PUT",
      }),
    }),

    // Change status
    changeaffidavitCertificateStatus: builder.mutation({
      invalidatesTags: ["affidavit-certificate", "pending-applications"],
      query: ({ body, id }: UpdateAffidavitCertificate) => ({
        url: `/affidavit-certificate/update-status`,
        params: { id },
        method: "PUT",
        body,
      }),
    }),

    //assignee
    // changeaffidavitCertificateApplicationAssignee: builder.mutation({
    //   invalidatesTags: ["affidavit-certificate"],
    //   query: ({ body, id }: updateAssignee) => ({
    //     url: `/affidavit-certificate/assign-to`,
    //     params: { id },
    //     method: "POST",
    //     body,
    //   }),
    // }),

    // GET STATUS COUNT
    getaffidavitCertificateStatusWiseCount: builder.query({
      providesTags: ["affidavit-certificate"],
      query: () => ({
        url: "/affidavit-certificate/get-allstatuscounts",
        method: "GET",
      }),
    }),

    // GET STATUS WISE APPLICATIONS

    //PENDING  REQUEST
    getaffidavitCertificatePendingApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-pending-applications",
        method: "POST",
        body,
      }),
    }),

    //VERIFIED  REQUEST
    getaffidavitCertificateVerifiedApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-verified-applications",
        method: "POST",
        body,
      }),
    }),
    //REJECTED  REQUEST
    getaffidavitCertificateRejectedApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-rejected-applications",
        method: "POST",
        body,
      }),
    }),
    //IN RPOGRESS  REQUEST
    getaffidavitCertificateInProgressApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-inprogress-applications",
        method: "POST",
        body,
      }),
    }),
 
    //Done REQUEST
    getaffidavitCertificateDoneApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-affidavit-applications",
        method: "POST",
        body,
      }),
    }),

   getaffidavitCertificateDoneApplicationById: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (id: string) => ({
        url: `/affidavit-certificate/get-application-by-id`,
        method: "GET",
        params: { id }, // ✅ query param
      }),
    }),

    //CANCELLED REQUEST
    getaffidavitCertificateCancelledApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-cancelled-applications",
        method: "POST",
        body,
      }),
    }),

    //Generate REQUEST
    getaffidavitCertificateGenerateApplications: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/get-generate-applications",
        method: "POST",
        body,
      }),
    }),

    // work history affidavitCertificate Application
    getaffidavitCertificateApplicationWorkHistory: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: any) => ({
        url: "/affidavit-certificate/admin-history",
        method: "POST",
        body,
      }),
    }),

    //To Get Payemnt summarry 
     
     getaffidavitCertificateApplicationPaymentSummary: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: any) => ({
        url: "/affidavit-certificate/payment-detail",
        method: "POST",
        body,
      }),
    }),


       // ADD
    addAffidavitCertificate: builder.mutation({
      invalidatesTags: ["affidavit-certificate"],
      query: (body) => ({
        url: "/affidavit-certificate/add",
        method: "POST",
        body,
      }),
    }),

    // GET GENERATED CERTIFICATES (only records with PDF generated)
    getGeneratedCertificates: builder.query({
      providesTags: ["affidavit-certificate"],
      query: (body: PaginationType & { generatedDateFilter?: any; startSerialNumber?: number }) => ({
        url: "/affidavit-certificate/get-generated-certificates",
        method: "POST",
        body,
      }),
    }),

    // EXPORT AFFIDAVIT CERTIFICATES LIST AS XLSX
    exportAffidavitCertificatesXlsx: builder.mutation({
      query: (body: PaginationType) => ({
        url: "/affidavit-certificate/export-affidavit-xlsx",
        method: "POST",
        body,
        responseHandler: (response: any) => response.blob(),
      }),
    }),

    // EXPORT GENERATED CERTIFICATES AS XLSX
    exportGeneratedCertificatesXlsx: builder.mutation({
      query: (body: PaginationType & { generatedDateFilter?: any; startSerialNumber?: number }) => ({
        url: "/affidavit-certificate/export-generated-xlsx",
        method: "POST",
        body,
        responseHandler: (response: any) => response.blob(),
      }),
    }),

  }),
});

export const {
  useGetaffidavitCertificateQuery,
  useGetSingleaffidavitCertificateQuery,
  useGetaffidavitCertificateApplicationPaymentSummaryQuery,
  // useChangeaffidavitCertificateApplicationAssigneeMutation,
  useGetaffidavitCertificatePendingApplicationsQuery,
  useChangeaffidavitCertificateStatusMutation,
  useExportHistoryaffidavitCertificateDataMutation,
  useGetaffidavitCertificateZipMutation,
  useGetaffidavitCertificateStatusWiseCountQuery,
  useGetaffidavitCertificateCancelledApplicationsQuery,
  useGetaffidavitCertificateDoneApplicationsQuery,
  useLazyGetaffidavitCertificateDoneApplicationByIdQuery,
  useGetaffidavitCertificateGenerateApplicationsQuery,
  useGetaffidavitCertificateInProgressApplicationsQuery,
  useGetaffidavitCertificateRejectedApplicationsQuery,
  useGetaffidavitCertificateVerifiedApplicationsQuery,
  useGetaffidavitCertificateApplicationFlowMutation,
  useGetaffidavitCertificateApplicationWorkHistoryQuery,
  useAddAffidavitCertificateMutation,
  useGetGeneratedCertificatesQuery,
  useExportAffidavitCertificatesXlsxMutation,
  useExportGeneratedCertificatesXlsxMutation
} = affidavitCertificateApi;
